import * as React from 'react';

import Caret8 from './Caret8';

export const caret8 = () => <Caret8 />;

export default {
    title: 'Icon/Fill/Caret8',
    component: Caret8,
    parameters: {
        notes: "`import Caret8 from 'box-ui-elements/es/icon/fill/Caret8';`",
    },
};
